// src/serviceWorkerRegistration.js
/* eslint-disable no-console */

async function tryRegister(path) {
  try {
    const head = await fetch(path, { method: "HEAD" });

    if (!head.ok) {
      console.warn(`[SW] El archivo ${path} no existe (HEAD ${head.status}).`);
      return null;
    }

    const registration = await navigator.serviceWorker.register(path);
    return registration;
  } catch (err) {
    return null;
  }
}

export async function register() {
  if (!("serviceWorker" in navigator)) return;

  window.addEventListener("load", async () => {
    await tryRegister("/sw_previonix.js");
  });
}

export async function unregisterAll() {
  const regs = await navigator.serviceWorker.getRegistrations();
  for (const reg of regs) await reg.unregister();
}
